import { Card, CardContent, Grid, Skeleton } from '@mui/material';

import styles from './CookingHistoryListSkeleton.module.css';

const CookingHistoryListSkeleton = () => (
  <Grid className={styles.container}>
    {[1, 2, 3, 4, 5].map((item, index) => (
      <Card className={styles.card} key={index}>
        <CardContent>
          <Grid className={styles.content}>
            <Skeleton
              className={styles.imageSkeleton}
              variant="rectangular"
            />

            <Grid className={styles.textSkeleton}>
              <Skeleton
                className={styles.textSkeletonSmall}
                variant="text"
              />

              <Skeleton
                className={styles.dateSkeleton}
                variant="text"
              />
              <Skeleton
                className={styles.savedSkeleton}
                variant="text"
              />

              <Skeleton
                className={styles.ratingSkeleton}
                variant="text"
              />
            </Grid>
          </Grid>

          <Grid className={styles.feedbackSkeleton}>
            <Skeleton variant="text" />
          </Grid>
        </CardContent>
      </Card>
    ))}
  </Grid>
);

export default CookingHistoryListSkeleton;
